module.exports = __webpack_public_path__ + "media/images/instructions/aws-iam-roles-1-another-account-01acdc3b59560722f0b43beef02d07f0.png";